import { createContext } from 'react'

export type InvertedColorsContextType = true

const InvertedColorsContext = createContext<
  InvertedColorsContextType | undefined
>(undefined)

export default InvertedColorsContext
